import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  dark?: boolean;
}

export default function Breadcrumb({ items, className = "", dark = false }: BreadcrumbProps) {
  return (
    <nav
      className={`flex items-center gap-1 text-xs flex-wrap ${className}`}
      aria-label="Breadcrumb"
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className={`ri-arrow-right-s-line ${dark ? "text-gray-600" : "text-gray-300"}`}></i>
            )}
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className={`transition-colors cursor-pointer hover:text-amber-500 ${
                  dark ? "text-gray-400 hover:text-amber-400" : "text-gray-400"
                }`}
              >
                {item.label}
              </Link>
            ) : (
              <span className={`font-medium ${dark ? "text-gray-200" : "text-gray-700"}`}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
